import { render, staticRenderFns } from "./SubscribeBlock.vue?vue&type=template&id=79d31bce&scoped=true"
import script from "./SubscribeBlock.vue?vue&type=script&lang=js"
export * from "./SubscribeBlock.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBlock.vue?vue&type=style&index=0&id=79d31bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d31bce",
  null
  
)

export default component.exports